module.exports = __webpack_public_path__ + "img/Szekely Tibor - Welder and Assembler.a4e40a9b.jpg";